<template>
    <section class="content">
        <div class='box box-info'>
          <div class="p-toolbar p-component mb-4">
          <transportationDetailsDialog ref="openDialog"/>
        </div>
          <transportationDetailsList @delete-message="deleteMessage" @edit-transportation="editTransportation" @view-transportation="viewTransportation"/>
        </div>
    </section>
  </template>
  <script>
  import transportationDetailsList from './transportationDetailsList.vue'
  import transportationDetailsDialog from '../billSundryDialog/transportationDetailsDialog.vue'
  
  export default {
    name: 'transportationDetails',
    methods: {
      editTransportation(data) {
        this.$refs.openDialog.editTransportation(data)
      },
      viewTransportation(data) {
        this.$refs.openDialog.viewTransportation(data)
      },
      deleteMessage(value) {
        this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
      }
    },
    components: {
      transportationDetailsList,
      transportationDetailsDialog
    }
  }
  </script>



// WEBPACK FOOTER //
// transportationDetails.vue?1545df6e